import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import { slugify } from '@finect/front-utils/slugify';
var users = function users(user) {
  return {
    id: user.id,
    type: user.type,
    displayName: user.displayName.trim(),
    avatarURL: user.icon ? "/image/".concat(user.icon) : null,
    username: user.alias,
    firstName: user.name,
    lastName: user.surnames,
    headline: user.headline,
    certification: user.certification,
    adviser: user.adviser,
    stats: user.stats,
    unreadMessages: user.unreadMessages,
    isLoggedIn: true,
    risk: user.risk
  };
};
var author = function author(rest) {
  return {
    id: rest.id,
    alias: rest.alias,
    displayName: rest.displayName,
    icon: rest.icon,
    image: "/image/".concat(rest.icon),
    subtype: rest.subtype,
    web: rest.web,
    isProfessional: rest.isProfessional,
    tagline: rest.tagline,
    certifications: rest.certifications,
    organizations: rest.organizations,
    isAdviser: rest.organizations.length > 0,
    link: "/usuario/".concat(rest.alias),
    stats: rest.stats
  };
};
var comment = function comment(model, authors) {
  return {
    id: model.id,
    author: author(authors.find(function (el) {
      return el.id === model.author;
    })),
    created: model.created,
    updated: model.updated,
    body: model.body,
    deleted: model.deleted
  };
};
var comments = function comments(rests, authors) {
  return rests.map(function (rest) {
    return comment(rest, authors);
  });
};
var review = function review(rest, authors) {
  return {
    id: rest.id,
    author: author(authors.find(function (el) {
      return el.id === rest.author;
    })),
    score: rest.score,
    title: rest.title,
    features: rest.features,
    body: rest.body,
    revision: rest.revision,
    socialStats: rest.socialStats,
    comments: comments(rest.comments, authors)
  };
};
var reviews = function reviews(rests, authors) {
  return rests.map(function (rest) {
    return review(rest, authors);
  });
};
var reviewFeature = function reviewFeature(rest) {
  return {
    alias: rest.alias,
    name: rest.name,
    description: rest.description
  };
};
var reviewFeatures = function reviewFeatures(rests) {
  return rests.map(function (rest) {
    return reviewFeature(rest);
  });
};
var question = function question(rest, authors) {
  return {
    id: rest.id,
    evergreen: rest.evergreen,
    title: rest.title,
    author: author(authors.find(function (el) {
      return el.id === rest.author;
    })),
    editorial: rest.editorial,
    body: rest.body,
    revision: rest.revision,
    stats: rest.stats,
    socialStats: rest.socialStats,
    link: "/preguntas/".concat(rest.id, "/").concat(slugify(rest.title))
  };
};
var questions = function questions(rests, authors) {
  return rests.map(function (rest) {
    return question(rest, authors);
  });
};
export var models = {
  users: users,
  author: author,
  review: review,
  reviews: reviews,
  comment: comment,
  comments: comments,
  reviewFeature: reviewFeature,
  reviewFeatures: reviewFeatures,
  question: question,
  questions: questions
};